import { useUnreadCountSelector } from "domains/concierge/internal/hooks/useUnreadCountSelector";

export const usePatientUnreadCount = (patientId?: string) => {
    return useUnreadCountSelector((state) => {
        return patientId
            ? state.conversations.unreadCounts.ticket.patients[patientId] ?? 0
            : 0;
    });
};
